import React from 'react';
import { useAuth } from '../../lib/auth';
import SinPermiso from '../../pages/SinPermiso';

/**
 * Renderiza children si el usuario tiene permiso al módulo.
 * Si no, muestra la pantalla de "Sin permiso".
 */
export const ModuleGuard = ({ moduleKey, moduleName, children }) => {
  const { hasModuleAccess, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!hasModuleAccess(moduleKey)) {
    return <SinPermiso moduleName={moduleName} />;
  }

  return children;
};

export default ModuleGuard;
